var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 23200"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.116211,
    y: 0.581055,
    width: 21.17,
    height: 21.17,
    rx: 10.585,
    fill: "url(#paint0_linear_6347_11219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M7.26109 4.60951C7.3115 4.393 7.61975 4.393 7.67016 4.60951L8.64031 8.77676C8.65614 8.84475 8.70472 8.90043 8.76993 8.92533L11.1518 9.83477C11.3319 9.90355 11.3319 10.1584 11.1518 10.2271L8.76993 11.1366C8.70472 11.1615 8.65614 11.2172 8.64031 11.2852L7.67016 15.4524C7.61975 15.6689 7.3115 15.6689 7.26109 15.4524L6.29094 11.2852C6.27511 11.2172 6.22653 11.1615 6.16132 11.1366L3.77944 10.2271C3.59932 10.1584 3.59932 9.90355 3.77945 9.83477L6.16132 8.92533C6.22653 8.90043 6.27511 8.84475 6.29094 8.77676L7.26109 4.60951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M13.036 11.4962C13.0841 11.2759 13.3983 11.2759 13.4464 11.4962L13.9676 13.8845C13.9824 13.9521 14.0295 14.0081 14.0936 14.0342L15.3887 14.5617C15.5631 14.6327 15.5631 14.8796 15.3887 14.9506L14.0936 15.4781C14.0295 15.5042 13.9824 15.5602 13.9676 15.6278L13.4464 18.0161C13.3983 18.2364 13.0841 18.2364 13.036 18.0161L12.5148 15.6278C12.5 15.5602 12.4529 15.5042 12.3888 15.4781L11.0937 14.9506C10.9194 14.8796 10.9194 14.6327 11.0937 14.5617L12.3888 14.0342C12.4529 14.0081 12.5 13.9521 12.5148 13.8845L13.036 11.4962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 3",
    d: "M14.8732 5.76173C14.9198 5.53915 15.2376 5.53915 15.2842 5.76173L15.5812 7.17904C15.5953 7.24633 15.6414 7.30245 15.7047 7.3293L16.4605 7.64994C16.6312 7.72233 16.6312 7.96419 16.4605 8.03658L15.7047 8.35722C15.6414 8.38407 15.5953 8.4402 15.5812 8.50748L15.2842 9.92479C15.2376 10.1474 14.9198 10.1474 14.8732 9.92479L14.5762 8.50748C14.5621 8.4402 14.516 8.38407 14.4527 8.35722L13.6969 8.03658C13.5263 7.96419 13.5263 7.72233 13.6969 7.64994L14.4527 7.3293C14.516 7.30245 14.5621 7.24633 14.5762 7.17904L14.8732 5.76173Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6347_11219",
    x1: 10.7012,
    y1: -34.8787,
    x2: 10.7012,
    y2: 67.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.238121,
    stopColor: "#00FFAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754977,
    stopColor: "#5F00FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAi);
export default __webpack_public_path__ + "static/media/ic_ai.7cfd47ef26ed8a235cd2f9da0b0e0d9f.svg";
export { ForwardRef as ReactComponent };